<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />

                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-button class="item" ref="replay" icon="replay" v-if="$route.query.in_search" primary @click="on_load" />

                <template v-if="permissible.indexOf('member.distribute') > -1">
                    <a-divider type="vertical" class="item" />
                    <a-button class="item" @click="on_distribute(selected_rows)" :disabled="!selected_row_keys.length">分配销售</a-button>
                </template>

                <span class="item selected" v-if="selected_row_keys.length">
                    已选中：
                    <span class="num">{{ selected_row_keys.length }}</span
                    >条
                </span>
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索姓名、手机号码" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <!-- 搜索结果 -->
        <search-field :field="search_field" />

        <!-- 主体表格 -->
        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                :custom-row="custom_row"
                size="middle"
                :scroll="{ x: true }"
                @change="(e) => on_pagination_change(e, path)"
            >
                <span slot="created_updated">
                    <a-dropdown>
                        <span>
                            {{ created_updated === "created" ? "录入时间" : "修改时间" }}
                            <a-icon type="down" />
                        </span>
                        <a-menu slot="overlay">
                            <a-menu-item v-if="created_updated == 'created'" @click="created_updated = 'updated'">修改时间</a-menu-item>
                            <a-menu-item v-if="created_updated == 'updated'" @click="created_updated = 'created'">录入时间</a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </span>

                <template slot="recharge_expense" slot-scope="text, record">
                    <table class="b-table">
                        <tbody>
                            <tr>
                                <td width="40">余额</td>
                                <td>{{ record.balance || "" }}</td>
                            </tr>
                            <tr>
                                <td>冻结</td>
                                <td>{{ record.balance_frozen || "" }}</td>
                            </tr>
                            <tr>
                                <td>总消费</td>
                                <td>{{ record.recharge_total || "" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <template slot="remark" slot-scope="text">
                    <div class="remark">{{ text }}</div>
                </template>

                <!-- 完整度 -->
                <template slot="level" slot-scope="text, record">
                    <a-tag class="level" :color="level_array[level_array.findIndex((v) => v.value == record.level)]['color']"
                        >L{{ record.level }}</a-tag
                    >
                </template>

                <!-- 客户信息   -->
                <template slot="info" slot-scope="text, record">
                    <div class="info">
                        <div class="name">
                            <a-badge :status="record.login_status == 1 ? 'success' : 'default'" />{{ record.name || "匿名" }}
                            <a-icon
                                v-if="record.verified_at"
                                :class="record.verified_type"
                                class="verified"
                                type="icon icon-renzheng"
                            ></a-icon>
                        </div>
                        <div class="qy">
                            <div class="name" v-if="record.com_name">
                                <a-icon type="icon icon-gongsi" /><a
                                    :href="'https://www.qcc.com/search?key=' + record.com_name"
                                    target="_blank"
                                    v-if="record.com_name.length > 5"
                                    >{{ record.com_name }}</a
                                >
                                <template v-else>
                                    {{ record.com_name }}
                                </template>
                            </div>
                            <div class="position" v-if="record.com_position">
                                <a-icon type="icon icon-gangwei" />{{ record.com_position_text }}
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 联系方式 -->
                <template slot="contact" slot-scope="text, record">
                    <table class="contact b-table">
                        <tbody>
                            <tr>
                                <td style="text-align:left" width="20">
                                    <i class="anticon anticon-icon icon-phone"></i>
                                </td>
                                <td @click="do_copy(record.mobile)" class="copy">{{ record.mobile }}</td>
                            </tr>
                            <tr v-if="record.qq">
                                <td style="text-align:left">
                                    <a-icon type="icon icon-qq1"></a-icon>
                                </td>
                                <td class="copy" @click="do_copy(record.qq)">{{ record.qq }}</td>
                            </tr>
                            <tr v-if="record.wechat_id">
                                <td style="text-align:left">
                                    <i class="anticon anticon-icon icon-we-chat-s"></i>
                                </td>
                                <td class="copy" @click="do_copy(record.wechat_id)">{{ record.wechat_id }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <!-- 跟进动态 -->
                <template slot="revisit" slot-scope="text, record">
                    <revisit-render :record="text" :member="record" :count="record.revisit_count" :callback="load" />
                </template>

                <!-- 跟进人信息 -->
                <template slot="user" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a"><a-badge :status="text.login_status == 1 ? 'success' : 'default'" />{{ text.name || "匿名" }}</div>
                        <div class="b" v-if="text.group">{{ text.group.name }}</div>
                    </div>
                </template>

                <!-- 注册信息 -->
                <template slot="registered" slot-scope="text, record">
                    <table class="registered b-table">
                        <tbody>
                            <tr>
                                <td style="width:35px">时间</td>
                                <td>
                                    <a-icon type="mobile" v-if="record.init_user_id == 0" style="color:#FF5722" />

                                    <span
                                        v-html="$options.filters['friendly'](moment(record.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                    ></span>
                                </td>
                            </tr>
                            <tr>
                                <td>最后</td>
                                <td>
                                    <span
                                        v-html="
                                            record.last_login
                                                ? $options.filters['friendly'](
                                                      moment(record.last_login.created_at * 1000).format('YYYY-MM-DD HH:mm')
                                                  )
                                                : '-'
                                        "
                                    ></span>
                                </td>
                            </tr>
                            <tr>
                                <td>次数</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-dropdown-button @click="on_distribute([record])" size="small">
                        分配销售
                        <a-menu slot="overlay">
                            <a-menu-item key="edit" @click="on_show(record)">详情</a-menu-item>
                            <a-menu-divider />
                            <a-menu-item key="move_folder" @click="on_move_tags([record])">移动到标签</a-menu-item>

                            <a-menu-item key="reset_password" @click="on_reset_password(record)">修改登录密码</a-menu-item>

                            <a-menu-divider />
                            <a-menu-item key="login_user" @click="on_login_user(record)">登录到用户端</a-menu-item>

                            <template v-if="permissible.indexOf('member.delete') > -1">
                                <a-menu-divider />
                                <a-menu-item key="disabled" @click="on_disabled(record)">禁用</a-menu-item>

                                <a-menu-item key="delete" @click="on_delete(record)">删除</a-menu-item>
                            </template>
                        </a-menu>
                    </a-dropdown-button>
                </template>
            </a-table>
        </div>

        <!-- 跟进动态 -->
        <modal_followup :visible="visible_followup" @close="visible_followup = false" @load="load" :callback="load" />

        <!-- 修改密码 -->
        <modal_resetpwd :visible="visible_resetpwd" @close="visible_resetpwd = false" :record="selected_record" />
    </div>
</template>

<script>
    import modal_followup from "../components/modal_followup.vue";
    import modal_resetpwd from "../components/modal_resetpwd";
    import common_pagination from "../../../mixins/common_pagination.js";

    import commonjs from "../mixins/common";
    import moment from "moment";

    export default {
        mixins: [common_pagination, commonjs],
        components: {
            modal_followup,
            modal_resetpwd,
        },
        data() {
            return {
                sub_title: "公海客户",
                path: "/member/public",
                loading: false,
                data_source: [],
                trigger: null,
                restoring: false,
                move_ids: [],
                visible_distribute: false,
                begin_at: +new Date(),
                wd: null,
                visible_followup: false,
                visible_search: false,
                visible_resetpwd: false,
                visible_show: false,
                selected_record: null,
                columns: [
                    {
                        dataIndex: "level",
                        width: 50,
                        scopedSlots: {
                            customRender: "level",
                        },
                    },
                    {
                        dataIndex: "id",
                        title: "编号",
                        width: 80,
                        scopedSlots: {
                            customRender: "id",
                        },
                    },
                    {
                        dataIndex: "info",
                        title: "客户信息",
                        scopedSlots: {
                            customRender: "info",
                        },
                        width: 150,
                    },
                    {
                        dataIndex: "contact",
                        title: "联系方式",
                        width: 130,
                        scopedSlots: {
                            customRender: "contact",
                        },
                    },
                    {
                        dataIndex: "demand_type_text",
                        title: "需求",
                        width: 100,
                    },
                    {
                        dataIndex: "recharge_expense",
                        title: "充值与消费",
                        width: 140,
                        scopedSlots: {
                            customRender: "recharge_expense",
                        },
                    },
                    {
                        dataIndex: "last_revisit",
                        title: "跟进动态",
                        width: 250,
                        scopedSlots: {
                            customRender: "revisit",
                        },
                    },
                    {
                        dataIndex: "registered",
                        title: "注册信息",
                        width: 180,
                        scopedSlots: {
                            customRender: "registered",
                        },
                    },
                    {
                        dataIndex: "init_user",
                        title: "初始录入信息",
                        width: 100,
                        scopedSlots: {
                            customRender: "user",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        scopedSlots: {
                            customRender: "remark",
                        },
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        width: 130,
                        align: "center",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        watch: {
            $route() {
                this.selected_row_keys = [];
                this.load();
            },
        },
        mounted() {
            this.load();
        },
        created() {
            this.$store.commit("change_state", {
                name: "member_sidebar_selected",
                value: "public",
            });
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/member/public?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;

                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            //每次加载完数据后再次统计
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_delete(record, force = false) {
                this.$confirm({
                    centered: true,
                    title: `是否要删除【${record.name}】`,
                    content: `${force ? "请注意，执行删除后将无法无法恢复。" : "该客户将会进入【已删除】标签。"}`,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete(force ? `member/force/${record.id}` : `customer/${record.id}`)
                                .then((res) => {
                                    if (res.success) {
                                        this.load();
                                    } else {
                                        this.$error({
                                            title: "失败",
                                            content: res.message,
                                        });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        });
                    },
                });
            },
            on_followup(record) {
                this.visible_followup = true;
            },
            on_reset_password(record) {
                this.visible_resetpwd = true;
                this.selected_record = record;
            },
        },
    };
</script>

<style lang="less" scoped>
    .framework-container {
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
            .main {
                overflow-y: auto;
                position: absolute;
                top: 57px;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }

    .info {
        .name {
            margin-bottom: 2px;
        }
        .qy {
            font-size: 12px;
            .anticon {
                margin-right: 2px;
            }
        }
    }

    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
    }

    .contact {
        width: 110px;
        font-size: 12px;
    }
    .expense {
        font-size: 12px;
    }

    .area {
        .city {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
        }
    }
    g {
        margin-right: 0;
    }
</style>
